import { existsBy, removeBy } from "neetocist";
import { filter, includes, toLower, trim } from "ramda";

export const getHidableColumns = columnData =>
  removeBy({ isHidable: false }, columnData);

export const filterBySearchTerm = (searchTerm, columns) =>
  filter(
    ({ title }) => includes(trim(toLower(searchTerm)), trim(toLower(title))),
    columns
  );

export const removeDeletedColumns = (hiddenColumns, columnData) =>
  hiddenColumns.filter(hiddenColumn =>
    existsBy({ dataIndex: hiddenColumn }, columnData)
  );
